(function () {
  function money(amount) {
    if (window.wetheme && typeof window.wetheme.formatMoney === 'function') {
      return window.wetheme.formatMoney(Number(amount) || 0);
    }
    return '$' + ((Number(amount) || 0) / 100).toFixed(2);
  }

  function normalizeCart(cart) {
    var items = Array.isArray(cart.items) ? cart.items : [];
    cart.items = items.filter(function (item) {
      return !(item.properties && item.properties._bundleId);
    }).map(function (item) {
      var featuredImage = item.featured_image && typeof item.featured_image === 'object' ? item.featured_image : {};
      var image = typeof item.image === 'string' ? item.image : featuredImage.url;
      var displayPrice = Number.isFinite(Number(item.final_price)) ? Number(item.final_price) : Number(item.original_price || item.price || 0);
      var compareAtPrice = Number(item.compare_at_price || 0);
      var allocations = Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : [];
      var firstAllocation = allocations[0] || item.line_level_discount_allocations || {};
      var discountApplication = firstAllocation.discount_application || {};

      item.image = image || '';
      item.featured_image_alt = featuredImage.alt || item.product_title || item.title || '';
      item.properties = item.properties || {};
      item.original_price = Number.isFinite(Number(item.original_price)) ? Number(item.original_price) : displayPrice;
      item.compare_at_price = compareAtPrice;
      item.display_price = money(displayPrice);
      item.display_compare_at_price = money(compareAtPrice);
      item.display_line_price = money(item.final_line_price || item.line_price || displayPrice * Number(item.quantity || 0));
      item.line_level_discount_allocations = {
        title: discountApplication.title || firstAllocation.title || '',
        amount: Number(firstAllocation.amount || 0)
      };
      return item;
    });
    cart.item_count = cart.items.reduce(function (total, item) {
      return total + Number(item.quantity || 0);
    }, 0);
    cart.total_price = Number(cart.total_price || 0);
    cart.display_total_price = money(cart.total_price);
    return cart;
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target instanceof Element ? event.target.closest('.js-drawer-open-right-link') : null;
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    window.fetch(root + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    }).then(function (cart) {
      if (!window.wetheme || typeof window.wetheme.toggleRightDrawer !== 'function') throw new Error('Cart drawer unavailable');
      window.wetheme.toggleRightDrawer('cart', true, { cart: normalizeCart(cart) });
    }).catch(function () {
      window.location.assign(target.href);
    });
  }, true);
})();
